export default __webpack_public_path__ + "f0ed655.png";